import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Local test page with made-up data (see src/dev/FieldLab.js). Not part of the production build.
const FieldLab = process.env.NODE_ENV === 'development' && new URLSearchParams(window.location.search).has('lab')
  ? React.lazy(() => import('./dev/FieldLab'))
  : null;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {FieldLab ? <React.Suspense fallback={null}><FieldLab /></React.Suspense> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
